<app-card [fullWidth]="true" [withCard]="false">
    <form autocomplete="off" [formGroup]="noFiscalGroupForm"
            class="form tw-flex tw-flex-col tw-gap-5">
        <section class="tw-grid tw-grid-cols-1 tw-gap-3 tw-px-1">
            <div class="tw-col-span-12">
                <mat-slide-toggle formControlName="goExit_skip_content" class="tw-py-3">
                    <span class="tw-flex tw-ml-2">{{'PRINTERS.GENERAL.SKIP_CONTENT' | translate}}</span>
                </mat-slide-toggle>
            </div>

            <div class="tw-col-span-12">
                <mat-slide-toggle formControlName="print_included_ingredients" class="tw-py-3">
                    <span class="tw-flex tw-ml-2">{{'PRINTERS.GENERAL.PRINT_INCLUDED_INGREDIENTS' | translate}}</span>
                </mat-slide-toggle>
            </div>
        </section>
    </form>
</app-card>